import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import AuthService from "../../utils/AuthService";
import axios from "axios";
import ApiMap from "../../utils/ApiMap";

function WaitForGameCode() {
  return (
    <Typography
      variant="h5"
      sx={{ color: "#FFEB3B", fontWeight: "bold", letterSpacing: 1 }}
    >
      LOADING...
    </Typography>
  );
}

function GameCode({
  contentid,
  courseid,
  chapterid,
  moduleid,
  setGamecode,
  children,
}) {
  const [gameCode, setGameCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getGameCode = async () => {
      try {
        const url = `${ApiMap.GET_GAMECODE}/coursegamecode/${courseid}/module/${moduleid}/chapter/${chapterid}/lesson/${contentid}`;
        const resp = await axios(url, AuthService.getAuthHeader());
        setGameCode(resp.data.gamecode);
        setGamecode(resp.data.gamecode, resp.data.ContentType);
      } catch (err) {
        console.error("Failed to fetch game code:", err);
      } finally {
        setLoading(false);
      }
    };

    if (AuthService.isFaculty(courseid)) {
      getGameCode();
    }
  }, [courseid, moduleid, chapterid, contentid, setGamecode]);

  if (!AuthService.isFaculty(courseid)) return null;

  // If children-as-function is provided, allow custom rendering
  if (typeof children === "function") {
    return children({ gameCode, loading });
  }

  return (
    <Box
      sx={{
        textAlign: "center",
        mt: 6,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "#fff",
      }}
    >
      {loading ? (
        <WaitForGameCode />
      ) : (
        <>
          <Typography
            variant="subtitle2"
            sx={{
              textTransform: "uppercase",
              color: "#BDBDBD",
              letterSpacing: "0.1em",
              fontWeight: "bold",
            }}
          >
            Game PIN
          </Typography>

          <Typography
            sx={{
              fontSize: "42px",
              color: "#2196f3",
              letterSpacing: "0.25em",
              fontWeight: 700,
              my: 1,
            }}
          >
            {gameCode}
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "#cfff22",
              fontFamily: "Quicksand, sans-serif",
              fontWeight: "bold",
            }}
          >
            Waiting for players...
          </Typography>
        </>
      )}
    </Box>
  );
}

export default GameCode;
